import type { MediaType } from "~/components/artworks/media/types";

export type SupportedLanguage = "pt" | "en" | "es";

export const SupportedLanguages: SupportedLanguage[] = ["pt", "en", "es"];
export const getLanguage = (language?: string) => {
  if (!language || !SupportedLanguages.includes(language as SupportedLanguage))
    return "pt";
  return language as SupportedLanguage;
};
export const getLanguageName = (language: string): string => {
  switch (language) {
    case "pt":
      return "Português";
    case "en":
      return "English";
    case "es":
      return "Español";
    default:
      return "Unknown";
  }
};

export const getMediaName = (
  mediaType: MediaType,
  lang: SupportedLanguage
): string => {
  switch (mediaType) {
    case "audioguide":
      return lang === "pt"
        ? "Audioguia"
        : lang === "es"
        ? "Guía de Audio"
        : "Audio guide";
    case "audiodescription":
      return lang === "pt"
        ? "Audiodescrição"
        : lang === "es"
        ? "Descripción de Audio"
        : "Audio description";
    case "signlanguage":
      return lang === "pt"
        ? "Libras"
        : lang === "es"
        ? "Lengua de Señas"
        : "Sign Language";
    case "video":
      return lang === "pt" ? "Vídeo" : lang === "es" ? "Video" : "Video";
    default:
      return "Unknown";
  }
};
